import { ChangeDetectionStrategy, Component, TemplateRef, contentChild, input } from '@angular/core';

@Component({
  selector: 'woo-table-column',
  standalone: true,
  template: '<ng-content></ng-content>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WooTableColumn {
  name = input.required<string>();
  header = input<string>('');
  readonly template = contentChild<TemplateRef<unknown>>(TemplateRef);
}
